(function () {
	const toggleNav = (nav, swiper) => {
		if (!nav) return;

		if (swiper.isLocked || swiper.snapGrid.length <= 1) {
			nav.classList.add('popular-products__nav--hidden');
		} else {
			nav.classList.remove('popular-products__nav--hidden');
		}
	};

	const initPopularProductsCarousel = () => {
		document.querySelectorAll('.js-popular-products-swiper').forEach((carousel) => {
			if (carousel.swiper) {
				carousel.swiper.destroy(true, true);
			}

			const section = carousel.closest('.popular-products');
			if (!section) return;

			const prev = section.querySelector('.js-popular-products-prev');
			const next = section.querySelector('.js-popular-products-next');
			const pagination = section.querySelector('.js-popular-products-pagination');
			const nav = section.querySelector('.js-popular-products-nav');

			const swiper = new Swiper(carousel, {
				slidesPerView: 1.2,
				slidesPerGroup: 1,
				spaceBetween: 16,
				slidesOffsetAfter: 20,
				watchOverflow: true,
				pagination: {
					el: pagination,
					type: 'fraction',
				},
				navigation: {
					prevEl: prev,
					nextEl: next,
				},
				breakpoints: {
					750: {
						slidesPerView: 2,
						slidesPerGroup: 2,
						spaceBetween: 20,
						slidesOffsetAfter: 0,
					},
					990: {
						slidesPerView: 3,
						slidesPerGroup: 3,
						spaceBetween: 24,
						slidesOffsetAfter: 0,
					},
					1200: {
						slidesPerView: 4,
						slidesPerGroup: 4,
						spaceBetween: 24,
						slidesOffsetAfter: 0,
					},
				},
				on: {
					init(instance) {
						toggleNav(nav, instance);
					},
					resize(instance) {
						toggleNav(nav, instance);
					},
					breakpoint(instance) {
						toggleNav(nav, instance);
					},
				},
			});
		});
	};

	document.addEventListener('DOMContentLoaded', initPopularProductsCarousel);
	document.addEventListener('shopify:section:load', initPopularProductsCarousel);
})();
